import ReactHtmlParser from 'react-html-parser';
import { ArrowLightCircleIcon } from '../../assets/icons';
import useAnimations from '../../helpers/animations';

function Info({ data }) {
    useAnimations({
        sections: [{
            section: 'section.about-body-section',
            animations: [
                { target: '.container > div.upper .text-block' },
                { target: '.container > div.upper .image img', scale: 1  },
                { target: '.container > div.bottom .text-block' },
                { target: '.container > div.bottom .image img', scale: 1  },
            ]
        }]
    });

    const [title_part1, title_part2] =
        data?.about_body_1?.title ? data.about_body_1.title.split('-') : [];
    const [subtitle1_part1, subtitle1_part2] = 
        data?.about_body_1?.subtitle ? data.about_body_1.subtitle.split('-') : [];
    const [subtitle2_part1, subtitle2_part2] =
        data?.about_body_2?.subtitle ? data.about_body_2.subtitle.split('-') : [];

    return (
        <section className="about-body-section bg-light">
            <div className="container">
                <div className="upper d-flex">
                    <div className="image">
                        <img src={data?.about_body_1.img_url} alt="team-members" />
                    </div>
                    <div className="text-block">
                        <h1 className="font-dark">
                            {title_part1}<span>{title_part2}</span>
                        </h1>
                        <div className="block d-flex">
                            <div className="d-flex">
                                <h2 className="font-dark">
                                    {subtitle1_part1}
                                </h2>
                                <div className="divider"></div>
                            </div>
                            <div className="d-flex">
                                <div className="divider"></div>
                                <div className="color-text">
                                    {subtitle1_part2}
                                </div>
                            </div>
                        </div>
                        {ReactHtmlParser(data?.about_body_1.description)}
                    </div>
                </div>
                <div className="bottom d-flex">
                    <div className="text-block">
                        <h2 className="font-dark">
                            {/* Our Commitment */}
                            {data?.about_body_2.title}
                        </h2>

                        <strong>
                            {ReactHtmlParser(subtitle2_part1)}
                            <br />
                            <br />
                            {ReactHtmlParser(subtitle2_part2)}
                        </strong>
                        <br />
                        <br />
                        {ReactHtmlParser(data?.about_body_2.description)}
                        <button className="gradient-btn">
                            <a href="/contact">
                                <span>
                                    {data?.about_body_2.button_name}
                                </span>
                                <ArrowLightCircleIcon />
                            </a>
                        </button>
                    </div>
                    <div className="image">
                        <img src={data?.about_body_2.img_url} alt="team-member" />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Info;